import React from 'react';

import english from './language.en';
import spanish from './language.sp';

export const dictionaries = { english, spanish };

export default React.createContext(english);
